export const RESULTS_PER_PAGE_ECHEANCES = 100;

export const ACTION_CREER_REMISE_BANCAIRE = 'creerRemiseBancaire';

export const EXPORT_EXCEL_TYPE_ECHEANCES = 'echeancepaiement';

export const ACTION_REPLANNIFER = 'replanifer';
